// extracted by mini-css-extract-plugin
export var resizer = "_hu-0";